
// スライダー設定

// 前後移動、ページャー付き
$('.js-slider-normal-ctrl').bxSlider({
    auto: false,
    infiniteLoop: true,
    // prevSelector: '.js-bx_prev',
    // nextSelector: '.js-bx_next',
    prevText: '<i class="icon-syg-arrowmini-left5"></i>',
    nextText: '<i class="icon-syg-arrowmini-right5"></i>',
    // pagerCustom: '.js-'
});


// 前後移動、ページャーオリジナル
// $('.js-slider-custom-ctrl').bxSlider({
//     auto: false,
//     infiniteLoop: true,
//     prevSelector: '.js-bx_prev',
//     nextSelector: '.js-bx_next',
//     prevText: '<i class="icon-syg-arrowmini-left5"></i>',
//     nextText: '<i class="icon-syg-arrowmini-right5"></i>',
//     pagerCustom: '.js-slider-custom-ctrl-pager'
// });





//////////////////
// WEBPACK FOOTER
// ./js/module/slider.js
// module id = 9
// module chunks = 0